import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'notistack'

import { useAppSelector } from '@/redux/rootReducer'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'
import { useAddPatientToQueueMutation } from '@/core/services/patient-queue'

export function usePatientsTableActions() {
  const { t } = useTranslation()
  const { enqueueSnackbar } = useSnackbar()
  const authUser = useAppSelector(selectAuthUser)
  const [addPatientToQueue] = useAddPatientToQueueMutation()

  const addToQueue = useCallback(
    async (patientId: string) => {
      try {
        if (!authUser?._id) return
        await addPatientToQueue({
          staffId: authUser._id,
          patient: patientId,
        }).unwrap()
        enqueueSnackbar(t('common:notification.success'), { variant: 'success' })
      } catch (e) {
        enqueueSnackbar(t('common:notification.error'), { variant: 'error' })
      }
    },
    [addPatientToQueue, authUser?._id, enqueueSnackbar, t]
  )

  return {
    addToQueue,
  }
}
